import React from 'react';
import PropTypes from 'prop-types';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Urls } from 'data';
import StandaloneAccountMenu from './StandaloneAccountMenu';

const PilgrimStandaloneShell = ({ children, showBackLink = false }) => (
  <div className="min-h-screen bg-[#f7f9f8] font-[Inter,sans-serif] text-[#26352c]">
    {showBackLink && (
      <header className="border-b border-[#dde5e0] bg-[#f7f9f8] px-4 sm:px-7">
        <div className="mx-auto flex min-h-[72px] max-w-[1460px] items-center justify-between gap-4">
          <Link
            to={Urls.profile.base}
            className="inline-flex min-h-10 items-center gap-2 rounded-md text-sm text-[#486154] hover:text-hajj-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-hajj-primary"
          >
            <ArrowLeft className="size-4" aria-hidden="true" />
            Retour au tableau de bord
          </Link>
          <StandaloneAccountMenu />
        </div>
      </header>
    )}
    {children}
  </div>
);

PilgrimStandaloneShell.propTypes = {
  children: PropTypes.node.isRequired,
  showBackLink: PropTypes.bool,
};

export default PilgrimStandaloneShell;
